<template>
  <div class="desc-cover" v-bind:class="{'left': align === 'left', 'right': align === 'right', 'center': align === 'center',}">
    <div v-if="title" class="desc-title">
        <span v-html="title"></span>
    </div>
    <div v-if="description" class="desc-text">
        <span v-html="description"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Description',
  data () {
    return {}
  },
  mounted () {
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.desc-cover {
  width: 100%;
  margin-bottom: 15px;
}
.desc-cover.left { 
  text-align: left;
}
.desc-cover.right { 
  text-align: right;
}
.desc-cover.center { 
  text-align: center;
}
.desc-cover .desc-title {
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  margin-bottom: 10px;
  font-family: 'HostGrotesk ExtraBold', sans-serif;
}

.desc-cover .desc-title .span {
  font-family: 'HostGrotesk ExtraBold', sans-serif;
}
.desc-cover .desc-text {
  color: var(--text-color1);
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  font-family: 'HostGrotesk Medium', sans-serif;
}

.desc-cover .desc-text .span {
  font-family: 'HostGrotesk ExtraBold', sans-serif;
}
.desc-cover .desc-text b {
  color: #000;
}
@media screen and (max-width: 650px) {
  div >>> h1 {
    font-weight: 700;
    font-size: 25px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/shared/widget/proposal/description.vue